import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconCheckBox = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <path
        d="M15,27 C8.373,27 3,21.627 3,15 C3,8.373 8.373,3 15,3 C21.627,3 27,8.373 27,15 C27,21.627 21.627,27 15,27 Z M15,25 C20.5228475,25 25,20.5228475 25,15 C25,9.4771525 20.5228475,5 15,5 C9.4771525,5 5,9.4771525 5,15 C5,20.5228475 9.4771525,25 15,25 Z"
        id="Combined-Shape"></path>
    </SvgIcon>
  );
};

IconCheckBox.displayName = 'IconCheckBox';
IconCheckBox.muiName = 'SvgIcon';

export default IconCheckBox;



// WEBPACK FOOTER //
// ./src/components/Icons/IconCheckBox.js